import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../../appointmentTask/actionTypes';

const initialState = {
  isLoading: false,
  apiError: null,
};

const fetchVerifyReducer = state => ({
  ...state,
  isLoading: true,
  apiError: null,
});

const verifySuccessReducer = state => ({
  ...state,
  isLoading: false,
});

const verifyFailureReducer = (state, { payload }) => ({
  ...state,
  isLoading: false,
  apiError: payload.message,
});

export default createReducer(initialState, {
  [actionTypes.POST_VERIFY]: fetchVerifyReducer,
  [actionTypes.POST_VERIFY_SUCCESS]: verifySuccessReducer,
  [actionTypes.POST_VERIFY_FAILURE]: verifyFailureReducer,
});
